import $ from 'jquery';
// import wx from 'weixin-js-sdk';
import NProgress from '@plugin/nprogress/nprogress.js';
import Toastr from '@plugin/toastr/toastr';

import qt_storage from '@libs/qt/storage';
import qt_md5  from '@libs/qt/md5';
import qt_base64 from '@libs/qt/base64';
import qt_util from '@libs/qt/util';

import _config from '@js/config';
import _log from '@js/log';
import _wxsign from '@js/wxsign';

//默认图片
var DEFAULT_IMG = require('@images/default.png');

export default (function(context,factory){

	return factory();

})(window,function(){

	var qt_model = {};
	NProgress.configure({tricklRate:0.05,trickleSpeed:800,showSpinner:false});

	//项目命名空间
	var _NAMESPACE = 'bxeSch';

	/**
	 * @desc 项目命名空间
	 */
	qt_model.NAMESPACE = _NAMESPACE;


	/**
	 * 切换学校
	 */
	qt_model.switchSchool = function(store,schoolCode){
		  const _schoolArrayStr = qt_storage.sessionGet('schoolArray_info');
		  const _schoolArray = _schoolArrayStr!=''?JSON.parse(_schoolArrayStr):undefined;
		  if(_schoolArray){
			_schoolArray.forEach(school => {
				if(school.schoolCode == schoolCode){
					qt_storage.sessionSet('current_school',JSON.stringify(school));
					qt_storage.sessionSet('current_school_pos',school.title);
					//设置用户的权限
					store.commit('setOwnAuthority',school.authority);
					console.log("切换成功");
				}
			});

		  }
	}


	/**
	 * 用户登陆后的对应数据的初始化动作
	 */
	qt_model.afterLoginInit = function(store,userId,userName,accessToken,schoolArray){
		qt_storage.sessionSet('access_token',accessToken);
		const _userInfo = {
			userId:userId,
			userName:userName
		};
		qt_storage.sessionSet('userInfo',JSON.stringify(_userInfo));
		let _schoolArray = [].concat(schoolArray);
		if(_schoolArray && _schoolArray.length>0){
			_schoolArray.forEach(item=>{
				 const _authority = item.authority ? JSON.parse(item.authority):{};
				 item.authority = _authority;
			});
			qt_storage.sessionSet('schoolArray_info',JSON.stringify(_schoolArray));
			qt_storage.sessionSet('current_school',JSON.stringify(_schoolArray[0]));
			//设置用户的权限
			store.commit('setOwnAuthority',_schoolArray[0].authority);
		}
		console.log("########afterLoginInit.done ##########");
	}


	qt_model.getSchoolCode = function(){
		var value = qt_storage.sessionGet('current_school');
		value = JSON.parse(value)
		return value?value.schoolCode:'';
	}


	qt_model.getSchoolList = function(){
		var value = qt_storage.sessionGet('schoolArray_info');
		value = JSON.parse(value)
		return value?value:[];
	}


	qt_model.getSchoolName = function(){
		var value = qt_storage.sessionGet('current_school');
		value = JSON.parse(value)
		return value?value.schoolName:'未知学校';
	}

	qt_model.getSchoolPosition = function(){
		var value = qt_storage.sessionGet('current_school');
		value = JSON.parse(value)
		return value?value.titleZh:'';
	}

	qt_model.getSchoolInfo = function(){
		var value = qt_storage.sessionGet('current_school');
		value = JSON.parse(value)
		return value;
	}


	/**
	 * @desc 获取userCode
	 * @return
	 */
	qt_model.getAccessToken= function(){
		var value = qt_storage.sessionGet('access_token');
		return value?value:'';
	}

	qt_model.setAccessToken = function(accessToken){
		qt_storage.sessionSet('access_token',accessToken);
	}

	/**
	 * @desc 删除userCode
	 * @return
	 */
	qt_model.delUserCode= function(){
		qt_storage.sessionDel('userCode');
	}



	/**
	 * @desc 获取用户名
	 * @return
	 */
	qt_model.getUserName = function(){
		var userBean = qt_model.getUserInfo();
		return userBean && userBean.userName ? userBean.userName:'未知';
	},

  //获取当前角色的企微corpId
  qt_model.getCorpId = function(){
    let role = qt_storage.sessionGet('current_school');
    role = JSON.parse(role);
    if(role && role.qyCorpId){
        return role.qyCorpId;
    }else{
        return '';
    }
  }

	/**
	 * @desc
	 * @return
	 */
	qt_model.getUserInfo = function(){
		var userInfo = qt_storage.sessionGet('userInfo');
		if(userInfo){
			return JSON.parse(userInfo);
		}else{
			return {};
		}
	}


	/**
	 * @desc 通用post请求
	 * @param {Object} options 请求参数对象
	 * @param {string} options.url 接口地址url
	 * @param {string} options.version 接口版本号
	 * @param {Object} options.params 接口业务参数
	 * @param {Function} [options.success] 成功回调，会返回data作为参数
	 * @param {Function} [options.fail] 失败回调，会返回相关信息
	 * @param {Function} [options.complete] 无论成功或失败都回调
	 * @param {boolean} options.stopStat 是否停止自动上报错误，有富文本的请求，请业务自己处理错误上报
	 */
	qt_model.post = (options = {}) => {
		let {url,version='1.0.0',timestamp,params={},accessToken,schoolCode,userId,signature, qyCorpId} = options;
		timestamp = timestamp?timestamp:qt_util.now();
		var urlParams = {
			version: version
		}
		let _url = url+(/\?/.test(url)?'&':'?') + qt_util.param(urlParams);

		//PC数据格式不需要传输
		/*
		let postData = {
			timestamp: timestamp,
			params: params
		}
		*/

		let postData = Object.assign({},params,{
			schoolCode:schoolCode,
			accessToken:accessToken,
			userId:userId,
			signature:signature,
      qyCorpId,
		});

		console.log('post--> params:');
		console.log(postData);

		//临时处理的协议规则
		signature && (postData.signature = signature);

		let _postDataStr = JSON.stringify(postData);
		_postDataStr = _config.postEncode?qt_base64.encode(_postDataStr):_postDataStr;

		// let _postDataStr = JSON.stringify(params);
		// _postDataStr = _config.postEncode?qt_base64.encode(_postDataStr):_postDataStr;

		//网络统计
		let _startTime = qt_util.now();
		let _reqid = qt_util.unique();
		WXSTAT.track('http_request',{
			url:_url,
			reqid: _reqid,
			start:_startTime
		});

		$.ajax({
			type : 'POST',
			url : _url,
			data : _postDataStr,
			contentType : 'application/json',
			dataType : 'json',
			success : function(res){

				//统一处理201的情况
				if(201 == res.resultCode){
					qt_model.hideProgress();
					qt_model.lostLogin();
				}else if(302 == res.resultCode){
					qt_model.hideProgress();

				}else{
					qt_model.hideProgress();
					if('01'!=res.resultCode && '09'!= res.resultCode){
						//非正常的业务逻辑
						options.success && options.success(res);
					} else if('09'==res.resultCode){
						//需要回到登陆页面
						qt_model.lostLogin();
					}else{
						options.success && options.success(res);
					}
				}
			},
			error : function(XMLHttpRequest, textStatus, errorThrown){
				//mta上报数据
				let _endTime = qt_util.now();
				WXSTAT.track('http_response',{
					url:_url,
					reqid:_reqid,
					statusCode:XMLHttpRequest.status,
					start:_startTime,
					end:_endTime,
					time:_endTime-_startTime
				});
				//专用上报
				let response = XMLHttpRequest.responseText;
				try{
					response = response.length>200?response.substring(0,200):response;
				}catch(e){
					//do nothing
				}
				!options.stopStat && _log.errorStat({
					type: _log.ERROR_TYPE_HTTP,
					data: {
						httpCode: XMLHttpRequest.status,
						response: response,
						url: _url,
						params: _postDataStr
					}
				});
				options.fail && options.fail({statusCode:XMLHttpRequest.status,data:XMLHttpRequest});
			},
			complete : function(XMLHttpRequest, textStatus){
				options.complete && options.complete();
			}
		});
	}

	/**
	 * @desc 通用post请求(签名)
	 * @param {Object} options 请求参数对象
	 * @param {string} options.url 接口地址url
	 * @param {string} options.version 接口版本号
	 * @param {Object} options.params 接口业务参数
	 * @param {Function} [options.success] 成功回调，会返回data作为参数
	 * @param {Function} [options.fail] 失败回调，会返回相关信息
	 * @param {Function} [options.complete] 无论成功或失败都回调
	 * @param {boolean} options.stopStat 是否停止自动上报错误，有富文本的请求，请业务自己处理错误上报
	 */
	qt_model.postSign = (options = {params:{}}) => {
		let timestamp = qt_util.now();
		var signature = _signature(timestamp);

		options.timestamp = timestamp;
		options.signature = signature;

		//通用参数、通过登陆验证的
		options.accessToken = qt_model.getAccessToken();
		options.schoolCode = qt_model.getSchoolCode();
    options.qyCorpId = options.qyCorpId || qt_model.getCorpId() || '';
    console.log(options.qyCorpId);
		const userInfo = qt_model.getUserInfo();
		options.userId = userInfo && userInfo.userId ? userInfo.userId:'';
		console.log(options);
		qt_model.post(options);
	}

	/**
	 * h5端通用post请求（登录状态）
	 */
	qt_model.wapPostSign = (options = {params:{}}) => {
		let userId = qt_storage.sessionGet('wapUserId');
		let openId = qt_storage.sessionGet('wapOpenId');
		options.params.userId = userId;
		options.params.openId = openId;
		qt_model.post(options);
	}

	/**
	 * @desc 根据接口时间戳计算签名
	 * @param {Number} timestamp 签名时间戳
	 * @return {String} 接口签名
	 */
	const _signature = (timestamp) => {
		var userCode = '';
		var sessionCode = '';
		userCode = userCode?userCode:'';
		sessionCode = sessionCode?sessionCode:'';
		var array = [sessionCode,userCode,timestamp];
		return qt_md5.md5(array.join(''));
	}



	/**
	 * @desc 丢失登录态通用处理方法
	 * @return
	 */
	qt_model.lostLogin = function(){
		//弹出消息提示框
		qt_model.showMsg({
			title: '提示',
			msg : '登录超时，需要重新登录！',
			okbtnText : '重新登录',
			textAlign: 'center',
			hidecanbtn: true,
			okcallback : function(){
				qt_model.goLogin(true);
			}
		});
	}

	/**
	 * @desc 清空用户所有状态信息
	 * @return
	 */
	qt_model.clearStatus = function(){
		//清除所有前端数据
		sessionStorage.clear();
	}

	/**
	 * @desc 返回登录页面
	 * @return
	 */
	qt_model.goLogin = function(){
		qt_model.clearStatus();
		location.hash='/login';
	}

	//progress
	//显示progress
	qt_model.showProgress = function(){
		NProgress.start();
	}
	//隐藏progress
	qt_model.hideProgress = function(){
		NProgress.done();
	}

	/**
	 * @desc 通用消息提示
	 * @param {String} level tips等级
	 * @param {String} msg 消息内容
	 * @param {Object} options 参数配置
	 * @return
	 */
	qt_model.tips = function(level,msg,options){
		var isMsgOpts = false;
		if(typeof msg == 'object'){
			isMsgOpts = true;
			options = msg;
		}
		var _msg = msg && !isMsgOpts?msg:level;
		var _level = msg && !isMsgOpts?level:'error';
		if(!_msg){
			return;
		}
		if(!options){
			options = {};
		}
		Toastr.options = {
		  "closeButton": false,
		  "debug": false,
		  "newestOnTop": false,
		  "progressBar": false,
		  "positionClass": "toast-bottom-center",
		  "preventDuplicates": false,
		  "onclick": null,
		  "showDuration": options.showDuration?options.showDuration:"300",
		  "hideDuration": options.hideDuration?options.hideDuration:"1000",
		  "timeOut": options.timeOut?options.timeOut:"2000",
		  "extendedTimeOut": options.extendedTimeOut?options.extendedTimeOut:"1000",
		  "showEasing": "swing",
		  "hideEasing": "linear",
		  "showMethod": "fadeIn",
		  "hideMethod": "fadeOut",
		  "onHidden" : options.onHidden
		}
		Toastr[_level]&&Toastr[_level](_msg);
	}

	/**
	 * @desc 通用消息提示
	 * @param {Object} options  对象集合
	 * @param {Object} options.title  标题
	 * @param {String} options.msg 消息内容
	 * @param {String} options.textAlign 对齐方式，默认center
	 * @param {String} options.canbtnText 关闭按钮文字
	 * @param {String} options.okbtnText 确认按钮文字
	 * @param {Function} options.cancallback 关闭按钮文字回调
	 * @param {Function} options.okcallback 确认按钮文字回调
	 * @param {Function} options.onClose 右上角关闭按钮 回调
	 * @param {Function} options.onShown 完全显示完 回调
	 * @param {Function} options.onHidden 完全隐藏完 回调
	 * @param {Function} options.mask 是否有灰色蒙层,默认true
	 * @param {Function} options.backdrop 灰色蒙层是否可点，默认false
	 * @param {Integer} options.width 窗口尺寸，默认400
     * @param {Function} options.callback 显示回调
	 * @return
	 */
     qt_model.showMsg = function(options){
		//马上校验
		var _options = {};
		if(typeof options == 'string'){
			_options.msg = options;
		}else{
			_options = options;
		}
		if(!_options.msg){
			return;
		}
		var title = _options.title?_options.title:'消息提示';
		title = false===_options.title?false:title;
		var msg = _options.msg;
		var callback = _options.callback;
        var cancallback = _options.cancallback;
		var okcallback = _options.okcallback;
		var canbtnText = _options.canbtnText?_options.canbtnText:(_options.okcallback?'取消':'知道了');
		var okbtnText = _options.okbtnText?_options.okbtnText:'确定';
		var mask = _options.mask === false?false:true;
		var textAlign = _options.textAlign?_options.textAlign:'left';
		var _width = _options.width?_options.width:400;
		var hidecanbtn = _options.hidecanbtn || false;

		var root = $('#cmMsgBox');
		var box = root.find('.wx-msgbox');
		if(title){
			box.find('.wx-msgbox-title').html(''+title).parent().show();
			$('.wx-msgbox-body').removeClass('wx-msgbox-notitle');
		}else{
			box.find('.wx-msgbox-title').html('').parent().hide();
			$('.wx-msgbox-body').addClass('wx-msgbox-notitle');
		}
		box.find('.wx-msgbox-body').html(''+msg);
		box.find('.wx-msgbox-body').css('text-align',textAlign);
		box.find('.wx-msgbox-footer').css('padding-bottom','30px');

		var _callback = callback;

		//处理按钮
		if(okcallback){
			box.find('.btn').eq(0).html(''+okbtnText).off().click(function(){
				root.removeClass('wx-msgbox-shown').addClass('wx-msgbox-hidden').hide();
				okcallback && okcallback();
			}).show();
			box.find('.btn').eq(1).html(''+canbtnText).off().click(function(){
				root.removeClass('wx-msgbox-shown').addClass('wx-msgbox-hidden').hide();
				cancallback && cancallback();
			}).show();
			if(hidecanbtn){
				box.find('.btn').eq(1).off().hide();
			}
		}else{
			box.find('.btn').eq(0).html(''+canbtnText).off().click(function(){
				root.removeClass('wx-msgbox-shown').addClass('wx-msgbox-hidden').hide();
				cancallback && cancallback();
			}).show();
			box.find('.btn').eq(1).off().hide();
		}
		box.find('.wxfont-close').off().on('click',function(){
			root.removeClass('wx-msgbox-shown').addClass('wx-msgbox-hidden').hide();
			_options.onClose && _options.onClose();
		});
		box.css({
			'width':_width+'px'
		});

		//处理
		box.off().on('transitionend',function(){
			if(root.hasClass('wx-msgbox-hidden')){
				//原本隐藏
				root.removeClass('wx-msgbox-hidden');
			}else{
				//原本已经显示
				root.addClass('wx-msgbox-hidden');
			}
			_callback && _callback();
		});
		root.show();
		setTimeout(function(){
			root.addClass('wx-msgbox-shown');
		},30);
	}




	/**
	 * @desc 居中弹出模态框
	 * @param {Object} options  对象集合
	 * @param {Function} options.selecter 模态框的选择器
	 * @param {Function} options.callback 关闭按钮回调
	 * @param {Function} options.okcallback 确认按钮回调
	 * @param {Function} options.onClose 右上角关闭按钮 回调
	 * @param {Function} options.onCheck 确认按钮点击关闭前的回调，return false不关闭窗口
	 * @param {Function} options.backdrop
	 * @return
	 */
	qt_model.showModal = function(options){
		var _options = {};
		if(!options){
			return;
		}
		if(typeof options == 'string'){
			_options.selecter = options;
		}else{
			_options = $.extend(_options,options);
		}
		if(!_options.selecter){
			return;
		}
		var callback = _options.callback;
		var okcallback = _options.okcallback;

		var box = $(_options.selecter);
		if(_options.okcallback){
			box.find('.btn').eq(0).off().click(function(){
				var flag = _options.onCheck?_options.onCheck():true;
				if(false !== flag){
					box.on('hidden.bs.modal',function(){
						box.off('hidden.bs.modal');
						okcallback && okcallback();
					});
					box.modal('hide');
				}
			});
			box.find('.btn').eq(1).off().click(function(){
				box.on('hidden.bs.modal',function(){
					box.off('hidden.bs.modal');
					callback && callback();
				});
				box.modal('hide');
			});
		}else{
			box.find('.btn').eq(0).off().click(function(){
				box.on('hidden.bs.modal',function(){
					box.off('hidden.bs.modal');
					callback && callback();
				});
				box.modal('hide');
			});
		}
		box.find('.close').off().on('click',function(){
			_options.onClose && _options.onClose();
		});
		box.css('z-index','1050').show();
		setTimeout(function(){
			var dialog = box.find('.modal-dialog');
			var w = dialog.width();
			var h = dialog.height();
			dialog.css({
				'position' : 'fixed',
				'top' : '50%',
				'left' : '50%',
				'absolute' : 'absolute',
				'margin-left':(-w/2)+'px',
				'margin-top':(-h/2)+'px'
			});
			box.hide();
			box.data('bs.modal',null);  //由于bootstrap.js中的modal实现方式引起 backdrop设置项不随option变化，这里置空bs.modal属性
			if(_options.backdrop){
				box.modal({
					'show' : true,
					backdrop : 'static'
				});
			}else{
				box.modal('show');
			}
		},20);
	}


	/**
	 * @desc 图片裁剪(金山云图片裁剪服务 http://ks3.ksyun.com/doc/imghandle/api/handle.html)
	 * @param imageUrl 图片原始地址
	 * @param options 裁剪图片参数(必须与金山云所提供的参数名称一样)
	 */
	qt_model.imgCrop=function(imageUrl,options){
		if(!/(weixiao.kssws.ks-cdn.com|ks3.weixiao100.cn)/.test(imageUrl)){
			//测试要处理的图片
			return imageUrl;
		}
		options = $.extend({},options?options:{});
		var _opts='';
		var html = new Array();
		for(var key in options){
			_opts ="&"+key +"="+ options[key];
			html.push(_opts);
		}
		imageUrl=imageUrl.replace(/@.*$/,'');
		var _imageUrl = imageUrl + "@base@tag=imgScale&r=1"+html.join('');
		_imageUrl = _imageUrl.replace(/^http\:/,'https:');
		return _imageUrl;
	}

	/**
	 * 判断手机端是否登录
	 */
	qt_model.wapCheckLogin=function(){
		if(qt_storage.sessionGet('wapUserId')){
			return true;
		}else{
			return false;
		}
	}

	qt_model.setUserIdAndOpenId=function(userId,openId,fCode){
		qt_storage.sessionSet('wapUserId',userId);
		qt_storage.sessionSet('wapOpenId',openId);
		qt_storage.sessionSet('wapfCode',fCode);
	}

	qt_model.getUserIdAndOpenId=function(){
		let userId = qt_storage.sessionGet('wapUserId');
		let openId = qt_storage.sessionGet('wapOpenId');
		let fCode = qt_storage.sessionGet('wapfCode');
		let returnData = {
			userId:userId,
			openId:openId,
			fCode:fCode
		}
		return returnData;
	}

	qt_model.storageSet = function(key,str){
		if (key && str){
			qt_storage.sessionSet(key,str);
		}
	},

	qt_model.storageSetObj = function(key,obj){
		if (obj){
		   qt_storage.sessionSet(key,JSON.stringify(obj));
		}
	},

	qt_model.storageGet = function(key){
		if (key){
			const val = qt_storage.sessionGet(key);
			return val?val:''
		}
		return ''
	},

	qt_model.storageGetObj = function(key){
		if (key){
			const val = qt_storage.sessionGet(key);
			return val?JSON.parse(val):{}
		}
		return undefined;
	}


	/**
	 * 回到功能的首页
	 */
	qt_model.goIndexPage = function( ){
		//判断当前用户的功能首页,多角色的时候的切换

		return '/clazz/list';
	}

	//------------------------------微信操作相关方法 begin------------------------------//


    //防止WeixinJSBridgeReady未准备好
	var waits = new Array();
	var WeixinJSBridgeReady = false;
	document.addEventListener('WeixinJSBridgeReady',function(){
        console.log('WeixinJSBridgeReady')
		WeixinJSBridgeReady = true;
		if(waits && waits.length>0){
            //这里其实应该用for循环会更合理，一般情况下不会并发，而且避免并发注入，所以这里先用pop
            var wait = waits.pop();
            if(2==wait.type){
                //企业微信
                let {corpId,appCode,jsApiList,httpUrl,func} = wait;
                _qywxConfig(corpId,appCode,jsApiList,httpUrl,func);
            }else{
                //普通微信
                let {corpId,appCode,jsApiList,httpUrl,func} = wait;
                _wxConfig(appId,jsApiList,httpUrl,func);
            }
		}
	});

    qt_model.qywxConfig = function (corpId,appCode,jsApiList,httpUrl,func){
        if(window.WeixinJSBridge){
			_qywxConfig(corpId,appCode,jsApiList,httpUrl,func);
		}else{
			waits.push({
                type:2,
                corpId,
                appCode,
                jsApiList,
                httpUrl,
                func
            });
        }
	}

    function _qywxConfig(corpId,appCode,jsApiList,httpUrl,func){
        httpUrl = httpUrl.replace(/\#.*$/,'');
        //agentConfig前要先执行wxConfig
        // qt_model.wxConfig(corpId,undefined,httpUrl,(res)=>{

            qt_model.post({
                url: _config.SERVICE + '/base/pc/qyadmin/manage/getJsTicket?corpId='+corpId+'&appCode='+appCode,
                version: '1.0.0',
                params: {},
                success: (res) => {
                    if("001" == res.resultCode){
                        let data = res.data;
                        var configObj = _wxsign(data.jsTicket,httpUrl);

                        console.log('wx.agentConfig start:',data);
						console.log('wx.agentConfig configObj:',configObj)
                        if(!wx){
                            console.log('wx not exist');
                            return;
                        }
                        wx.agentConfig({
                            corpid: data.corpId,
                            agentid: data.agentId,
                            timestamp: configObj.timestamp,
                            nonceStr: configObj.nonceStr,
                            signature: configObj.signature,
                            jsApiList: jsApiList,
                            success: function(res) {
                                console.log('wx.agentConfig success:');
                                // 回调
                                if(func){
                                    func(data.appId);
                                }
                            },
                            fail: function(res) {
                                console.error('wx.agentConfig fail:',res);
                                if(res.errMsg.indexOf('function not exist') > -1){
                                    alert('版本过低请升级')
                                }
                            }
                        });
                        wx.error(function(res){
                            // alert(JSON.stringify(res));
                        });
                    }else{
                        alert(res.resultMsg);
                    }
                },
                fail: (res) => {
                    alert('/base/qy/oauth/getJsTicket服务异常，请稍后重试'+res.statusCode);
                }
            });

        // })
	}

	qt_model.wxConfig = function (appId,jsApiList,httpUrl,func){
        if(window.WeixinJSBridge){
			_wxConfig(appId,jsApiList,httpUrl,func);
		}else{
			waits.push({
                type:1,
                appId,
                jsApiList,
                httpUrl,
                func
            });
        }
	}

    function _wxConfig(appId,jsApiList,httpUrl,func){

        httpUrl = httpUrl.replace(/\#.*$/,'');

        if(!jsApiList||jsApiList.length<=0){
            jsApiList = ["hideAllNonBaseMenuItem"]
        }
		qt_model.post({
			url: _config.SERVICE + '/base/mp/support/getMJsTicket',
			version: '1.0.0',
			params: {},
			success: (res) => {
				if("001" == res.resultCode){
					var configObj = _wxsign(res.data.ticket,httpUrl);

                    console.log('wx.ready start:',res.data.ticket);

					wx.config(
						{
							debug: false,
							appId: appId,
							timestamp: configObj.timestamp,
							nonceStr: configObj.nonceStr,
							signature: configObj.signature,
							jsApiList: jsApiList
						}
					);

					wx.ready(function () {

                        console.log('wx.ready finish')
						qt_model.checkJsApi(jsApiList);
						if(func){
							func();
						}
					});
					wx.error(function(res){
						// alert(JSON.stringify(res));
					});
				}
			},
			fail: (res) => {
				alert('/base/mp/support/getMJsTicket服务异常，请稍后重试'+res.statusCode);
			}
		});
	}


	qt_model.checkJsApi = function (p_js_apiList) {
		wx.checkJsApi({
		  jsApiList: p_js_apiList,
		  success: function (res) {

		  }
		});
	}

	qt_model.closeWxWindow=function(){
		wx.closeWindow();
	}

	qt_model.hideAllNonBaseMenuItem=function(){
		wx.hideAllNonBaseMenuItem();
	}


	//------------------------------微信操作相关方法 end------------------------------//

	//------------------------------window方法 begin------------------------------//

	/**
	 * @desc 图片居中自适应处理函数，使用条件是img必须有父元素作为wrapper
	 * @param {Object} img  要做自适应的图片dom对象，一般在<img onload="winFixImg(this);" />
     * @param {Object} isCompress  是否使用等比压缩方式，默认是等比裁剪
	 * @return
	 */
	window.winFixImg  = function(img,isCompress){
		var _width = img.naturalWidth;
		var _height = img.naturalHeight;
		var _img = $(img);
		var _parent = _img.parent();
		var _pPaddingL = _parent.css('padding-left');
		var _pPaddingR = _parent.css('padding-right');
		var _pPaddingT = _parent.css('padding-top');
		var _pPaddingB = _parent.css('padding-bottom');
		_pPaddingL = _pPaddingL?parseInt(_pPaddingL.replace('px')):0;
		_pPaddingR = _pPaddingR?parseInt(_pPaddingR.replace('px')):0;
		_pPaddingT = _pPaddingT?parseInt(_pPaddingT.replace('px')):0;
		_pPaddingB = _pPaddingB?parseInt(_pPaddingB.replace('px')):0;
		var _pWidth = _parent.width() - _pPaddingL - _pPaddingR;
		var _pHeight = _parent.height() - _pPaddingT - _pPaddingB;
		if(!_pWidth){
			_pWidth = _parent.css('width');
			_pWidth = _pWidth?parseInt(_pWidth.replace('px')):0;
		}
		if(!_pHeight){
			_pHeight = _parent.css('width');
			_pHeight = _pHeight?parseInt(_pHeight.replace('px')):0;
		}

		var rate = _pWidth/_pHeight;
		var imgrate = _width/_height;

		var translateX = 0;
		var translateY = 0;
		var tWidth = _pWidth;
		var tHeight = _pHeight;

		if(imgrate >= rate){
			//图片比默认比率更宽
			if(isCompress){
				tWidth = _pWidth;
				tHeight = _pWidth*_height/_width;
				translateY = (_pHeight - tHeight)/2;
			}else{
				//裁剪，需要水平偏移
				tWidth = _width * tHeight / _height ;
				translateX = (_pWidth - tWidth)/2;
			}
		}else{
			//图片比默认比率更高
			if(isCompress){
				tHeight = _pHeight;
				tWidth =   _width * _pHeight / _height;
				translateX = (_pWidth - tWidth)/2;
			}else{
				//裁剪，需要垂直偏移
				tHeight = _height * tWidth / _width;
				translateY = (_pHeight - tHeight)/2;
			}

		}

		//微校只支持IE9+,直接使用transform,如需兼容IE8,需要修改
		_parent.css({
			'overflow' : 'hidden'
		});
		_img.css({
			'width' : tWidth+'px',
			'height' : tHeight +'px',
			'transform' : 'translate('+translateX+'px,'+translateY+'px)',
			'-ms-transform' : 'translate('+translateX+'px,'+translateY+'px)',
			'-webkit-transform' : 'translate('+translateX+'px,'+translateY+'px)'
		});
	}

	/**
	 * @desc 图片加载错误设置默认图片
	 * @param {Object} img  要做处理的图片dom对象，一般在<img onerror="winErrorImg(this);" />中使用
	 * @return
	 */
	window.winErrorImg  = function(img){
		img.src= DEFAULT_IMG ;
	}
    window.winErrorFaceImg  = function(img){
        img.src= DEFAULT_FACE ;
    }

	//------------------------------window方法 end--------------------------------//


    /**
     * 获取全部文章或者根据KEY获取本地缓存中文文章
     * @param key
     */
    qt_model.getArticle = function (key){
        const defaultArticle = {url: 'https://mp.weixin.qq.com/s?__biz=MzU4NTYzNTUzMA==&mid=100000012&idx=2&sn=2c5af98f5349b79baa000f6951f8d7b8&chksm=7d86c2a94af14bbf5d823910ba24ea418d5675589bdb82016a3e1e50b9f83820d6d5ab7c4405#rd'};
        return new Promise(async (resolve, reject) => {
            qt_model.postSign({
                url: _config.SERVICE + '/base/pro/schadm/common/getArticle',
                version: '1.0.0',
                params: {
                    key
                },
                success: (res) => {
                    if("001" == res.resultCode && res.data){
                        resolve(res.data);
                    }else {
                        resolve(defaultArticle);
                    }
                },
                fail:(res)=>{
                    resolve(defaultArticle);
                }
            });
        })
    }

	return qt_model;
});




// WEBPACK FOOTER //
// ./src/js/common.js